/** Props for {@link CheckIcon}. */
interface CheckIconProps {
  /** Icon width (default `1rem`). */
  width?: string;
  /** Icon height (default `1rem`). */
  height?: string;
  /** Stroke colour for the check (default `#008F32`). */
  color?: string;
}

/**
 * Plain check-mark icon (no surrounding circle), used beside the
 * "Review Summary" heading.
 *
 * @param props - Optional size and stroke colour overrides
 * @returns The rendered check SVG
 */
export function CheckIcon(props: CheckIconProps) {
  const size = {
    width: props.width || "1rem",
    height: props.height || "1rem",
  };
  const stroke = props.color || "#008F32";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size.width}
      height={size.height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3 8L6.5 11.5L13 4"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
